"use client";

import { BookOpen, Network, Briefcase, Users, Newspaper, Shield, HeartHandshake } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ZonaPPCategoryGrid() {
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: dashboardRef,
    isVisible: dashboardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const categories = [{
    icon: BookOpen,
    title: "Profil & Sejarah",
    slug: "profil-sejarah",
    desc: "Menelusuri rekam jejak, visi misi, dan sejarah panjang perjuangan Pemuda Pancasila dalam menjaga ideologi negara."
  }, {
    icon: Network,
    title: "Struktur & Hierarki",
    slug: "struktur-hierarki",
    desc: "Informasi lengkap mengenai bagan organisasi dan tata kelola kepemimpinan dari tingkat pusat hingga basis."
  }, {
    icon: Briefcase,
    title: "Badan Lembaga & Sayap",
    slug: "badan-lembaga-sayap",
    desc: "Mengenal berbagai unit fungsional, badan otonom, dan organisasi sayap yang bergerak di berbagai sektor strategis."
  }, {
    icon: Users,
    title: "Tokoh & Senior",
    slug: "tokoh-senior",
    desc: "Profil para tokoh bangsa dan kader senior yang telah memberikan kontribusi nyata bagi kemajuan organisasi."
  }, {
    icon: Newspaper,
    title: "Warta & Agenda",
    slug: "warta-agenda",
    desc: "Kumpulan berita terkini, rilis resmi, dan jadwal kegiatan nasional Pemuda Pancasila di seluruh wilayah."
  }, {
    icon: HeartHandshake,
    title: "Layanan Organisasi",
    slug: "layanan-organisasi",
    desc: "Pusat layanan anggota, bantuan hukum, pemberdayaan ekonomi, dan sistem keanggotaan digital terpadu."
  }];
  return <section data-section-id="6602" id="zonappcategorygrid" className="bg-background text-foreground py-16 md:py-24 lg:py-32 pb-[110px] md:pb-[120px]">
      <div className="mx-auto max-w-[1180px] px-5 md:px-8">
        <div ref={gridRef} className="mt-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {categories.map((item, i) => {
          const Icon = item.icon;
          return <div key={item.slug} data-index={i} className={`group flex flex-col h-full rounded-lg border border-border bg-white p-5 md:p-8 transition-all duration-500 ease-in-out hover:shadow-lg hover:-translate-y-1 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: gridVisible ? `${i * 100}ms` : "0ms"
          }}>
                <div className="flex flex-col sm:flex-row items-start gap-3 md:gap-4 mb-4 md:mb-6">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary text-white transition-transform duration-300 group-hover:scale-110 shadow-md">
                    <Icon className="h-6 w-6" strokeWidth={2} />
                  </div>
                  <div className="pt-0 md:pt-1">
                    <h3 className="font-sans text-base md:text-xl font-bold tracking-tight text-primary leading-tight">
                      {item.title}
                    </h3>
                  </div>
                </div>

                <p className="text-[0.875rem] md:text-[1rem] leading-relaxed text-black mb-6 md:mb-8 flex-grow line-clamp-3 md:line-clamp-none">
                  {item.desc}
                </p>

                <div className="mt-auto pt-4 md:pt-6 border-t border-border">
                  <Button asChild variant="default" className="w-full h-10 md:h-11 rounded-lg bg-primary text-white font-semibold hover:bg-primary/90 transition-all duration-300 text-xs md:text-sm border-none shadow-sm">
                    <Link to={`/zona-pp/${item.slug}/`}>
                      Lihat Selengkapnya
                    </Link>
                  </Button>
                </div>
              </div>;
        })}
        </div>

        <div ref={dashboardRef} className={`mt-12 md:mt-16 transition-all duration-600 ease-in-out ${dashboardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="group relative overflow-hidden rounded-lg p-6 md:p-10 shadow-md hover:shadow-xl transition-all duration-300 bg-accent border border-primary/20">
            <div className="absolute top-0 right-0 -mt-4 -mr-4 h-32 w-32 rounded-lg bg-primary/5 blur-3xl group-hover:bg-primary/10 transition-colors duration-500" />
            
            <div className="relative flex flex-col md:flex-row items-center justify-between gap-8">
              <div className="flex flex-col md:flex-row items-center justify-center text-center md:text-left gap-6">
                <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-primary text-white shadow-lg shadow-primary/20">
                  <Shield className="h-8 w-8" strokeWidth={1.5} />
                </div>
                <div className="flex flex-col items-center md:items-start">
                  <h3 className="font-sans text-2xl md:text-3xl font-bold tracking-tight text-foreground mb-2">
                    Dashboard Zona PP
                  </h3>
                  <p className="max-w-[600px] text-base md:text-lg text-muted-foreground leading-relaxed">
                    Akses pusat kendali digital untuk memantau aktivitas organisasi, data keanggotaan, dan laporan kinerja secara real-time.
                  </p>
                </div>
              </div>
              
              <div className="shrink-0 w-full md:w-auto">
                <Button asChild size="lg" className="w-full md:w-auto h-12 md:h-14 px-8 rounded-lg text-base font-bold bg-primary text-white shadow-lg shadow-primary/20 hover:shadow-primary/30 hover:bg-primary/90 transition-all duration-300 border-none">
                  <Link to="/AccountPage">
                    Login ke Dashboard
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}